// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITotalEmployeeContributionDto
 */
export interface ITotalEmployeeContributionDto {
    /**
     * 
     * @type {number}
     * @memberof ITotalEmployeeContributionDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ITotalEmployeeContributionDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ITotalEmployeeContributionDto
     */
    total_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ITotalEmployeeContributionDto
     */
    tax_year?: number;
}

/**
 * Check if a given object implements the ITotalEmployeeContributionDto interface.
 */
export function instanceOfITotalEmployeeContributionDto(value: object): value is ITotalEmployeeContributionDto {
    return true;
}

export function ITotalEmployeeContributionDtoFromJSON(json: any): ITotalEmployeeContributionDto {
    return ITotalEmployeeContributionDtoFromJSONTyped(json, false);
}

export function ITotalEmployeeContributionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITotalEmployeeContributionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'total_contribution_amount': json['total_contribution_amount'] == null ? undefined : json['total_contribution_amount'],
        'tax_year': json['tax_year'] == null ? undefined : json['tax_year'],
    };
}

export function ITotalEmployeeContributionDtoToJSON(json: any): ITotalEmployeeContributionDto {
    return ITotalEmployeeContributionDtoToJSONTyped(json, false);
}

export function ITotalEmployeeContributionDtoToJSONTyped(value?: ITotalEmployeeContributionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'employee_id': value['employee_id'],
        'total_contribution_amount': value['total_contribution_amount'],
        'tax_year': value['tax_year'],
    };
}

